// Utilities for safely reading ticket fields and deriving display values

export function pick(obj, ...paths) {
  for (const p of paths) {
    const parts = Array.isArray(p) ? p : String(p).split(".");
    let cur = obj;
    let ok = true;
    for (let part of parts) {
      if (!cur) {
        ok = false;
        break;
      }
      const variants = [
        part,
        part.charAt(0).toLowerCase() + part.slice(1),
        part.charAt(0).toUpperCase() + part.slice(1),
      ];
      let found;
      for (const v of variants) {
        if (Object.prototype.hasOwnProperty.call(cur, v)) {
          found = cur[v];
          break;
        }
      }
      if (found === undefined) {
        ok = false;
        break;
      }
      cur = found;
    }
    if (ok) return cur;
  }
  return undefined;
}

export function extractQuoteId(ticket) {
  const customFields = pick(ticket, "CustomFields") || pick(ticket, "customFields") || [];
  if (Array.isArray(customFields)) {
    const match = customFields.find((cf) => {
      const name = pick(cf, "Caption") || pick(cf, "Name") || "";
      return typeof name === "string" && /quote\s*id|quote/i.test(name);
    });
    if (match) {
      const val =
        pick(match, "Value") ??
        pick(match, "ValueText") ??
        pick(match, "ValueNumber") ??
        pick(match, "ValueBool") ??
        pick(match, "value");
      if (val !== undefined && val !== null && String(val).trim().length > 0) return String(val);
    }
  }
  const oppId = pick(ticket, "Opportunity.Id") ?? pick(ticket, "opportunity.id");
  if (oppId) return String(oppId);
  const kbLink = pick(ticket, "KnowledgeBaseLinkId") ?? pick(ticket, "knowledgeBaseLinkId");
  if (kbLink) return String(kbLink);
  return "N/A";
}

export function extractProjectNumber(ticket) {
  const wbs = pick(ticket, "WbsCode") ?? pick(ticket, "wbsCode");
  if (wbs) return String(wbs);
  const projId = pick(ticket, "Project.Id") ?? pick(ticket, "project.id");
  if (projId) return String(projId);
  const projName = pick(ticket, "Project.Name") ?? pick(ticket, "project.name");
  if (projName) return String(projName);
  return "N/A";
}
